import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-wrapper">
      <div className="container footer-flex">
        <div className="footer-section">
          <h3>YK Mart</h3>
          <p>Your trusted partner for quality products and organic farming solutions.</p>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/harvest">YK Harvest</Link></li>
            <li><Link to="/cart">Cart</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
            <li><a href="https://yklaboratories.com/" target="_blank" rel="noopener noreferrer">YK Laboratories</a></li>
            <li><a href="https://siteadmin.ykmart.in/login" target="_blank" rel="noopener noreferrer">Admin Login</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Customer Service</h4>
          <ul>
            <li><Link to="/orders">My Orders</Link></li>
            <li><Link to="/wishlist">Wishlist</Link></li>
            <li><Link to="/track">Track Order</Link></li>
            {/* <li><a href="mailto:support@ykmart.com">Support</a></li> */}
          </ul>
        </div>
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>Email: info@ykmart.in</p>
          <p>Phone: +91 970 512 9639 / +91 949 141 8181</p>
          <p>Address: SY.NO. 255, PLOT NO.3, EAST PART, KUNTLOOR (V), HAYATHNAGAR, R.R. DIST. TELANGANA - 501505. INDIA.</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 YK Mart. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;